import { styled } from 'styled-components';

const PageStyled = styled.div`
  height: 100vh;
  background-color: #e9eded;
  position: relative;
`;

export default PageStyled;
